<template>
    <div>
        <layout-headers title="distributorsPageTitle" text="distributorsPageSubtitle" :redirectButtons="redirectButtons" />

        <filters 
            :tableData="tableData" 
            v-model="search" 
            @filtered-list="getFilteredList" 
            :fields="['legal_name', 'city', 'email', 'web']"
        />
        <br>
        <el-card>
        <el-table :data="filteredData" empty-text="No results">
            <el-table-column
                width="80"
                prop="logo"
                :label="$t('providerAvatar')">
                <template slot-scope="scope">
                    <img @error="scope.row.logo = ''" :src="scope.row.logo ? url + scope.row.logo+ '?q='+ timestamp : defaultImage">
                </template>
            </el-table-column>

            <el-table-column sortable prop="legal_name" :label="$t('providerLegalName')"/>
            <el-table-column sortable prop="display_name.en" :label="$t('providerDisplayName')"/>
            <el-table-column sortable prop="city" :label="$t('providerCity')"/>
            <el-table-column sortable prop="provider_type.type_name" :label="$t('providerProviderType')"/>
            
            <el-table-column prop="actions" fixed="right" :label="$t('tableActions')">
                <template slot-scope="scope">
                    <el-tooltip 
                        class="item" 
                        effect="dark"
                        placement="left-start">
                        <div slot="content">
                            {{ $t('tooltipInfo') }}
                        </div>
                        <el-button type="info" 
                            icon="el-icon-view"
                            class="table-button"
                            @click="$router.push({name: 'SingleProvider', params: {id: scope.row.id}})">
                        </el-button>
                    </el-tooltip>
                    <el-button type="primary" icon="el-icon-edit" class="table-button" @click="edit('ProviderEdit', scope.row, 'provider')"/>
                    <el-button type="danger" icon="el-icon-delete" class="table-button" @click="showModal(scope.row.id, scope.$index)"/>
                </template>
            </el-table-column>
        </el-table>
        </el-card>
        <modal :config="modalConfig" @closeModal="deleteDistributors" />
    </div>
</template>

<script>
    import {ImageUrl} from '@/main'
    import {mapGetters} from 'vuex'
    import api from '@/api/api';
    import LayoutHeaders from '../LayoutPart/LayoutHeaders';
    import Filters from '../Filters/Filter';
    import Modal from '../Modal/Modal'
    import { success } from '../Notification/notification';
    import {getFilteredList, edit} from '@/helpers/helpers';
    import {showModal, closeModal} from "../Modal/ModalHelpers";
    import noImage from '@/assets/no_image.png'

    export default {
        name: 'distributors',
        components: {
            LayoutHeaders,
            Filters,
            Modal
        },
        computed: {
            ...mapGetters({
                distributors: 'getDistributors'
            }),
            timestamp() {
                return Date.now();
            }
        },
        data () {
            return {
                id: null,
                index: null,
                filteredData: [],
                modalConfig: { show: false },
                search: '',
                tableData: [],
                url: ImageUrl,
                defaultImage: noImage,
                redirectButtons: [
                    {
                        path: 'ProviderAdd',
                        param: {
                            isEdit: false,
                            provider: {
                                id: null,
                                user_id: null,
                                provider_type_id: 1,
                                legal_name: '',
                                display_name: {},
                                logo: '',
                                city: '',
                                zip: '',
                                address: '',
                                phone: '',
                                fax: '',
                                email: '',
                                description: {},
                                web: '',
                                imageData: ''
                            }
                        },
                        text: 'distributorsButton'
                    }
                ]
            }
        },
        async created () {
            await this.$store.dispatch('fetchDistributors')
        },
        watch: {
            distributors() {
                this.filteredData = this.distributors;
                this.tableData = this.distributors;    
            }
        },
        methods: {
            edit,
            getFilteredList,
            success,
            showModal,
            closeModal,
            deleteDistributors() {
                const id = this.id;
                this.dialogVisible = false;

                api.deleteProvider(id).then(() => {
                    this.$delete(this.distributors, this.index);
                    this.success('Distributors', 'deleted');
                }).catch(err => {
                })
            }
        }
    }
</script>


<style scoped>
    .table-button {
        width: 30px !important; 
        height: 30px !important; 
        padding: 0 !important; 
        margin: 0 !important;
        background: transparent !important;
        color: darkgrey;
        font-size: 20px;
        font-weight: 800;
        border: none;
    }

    .table-button:hover {
        color: #409EFF !important;
    }
    .cell img {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Providers/DistributorsTable.vue